import m from "mithril";
import Auth from "../../shared/auth";
import i18n from "../../shared/i18n/i18n";
import Component_Organisation_Details from "./component_organisation_details";
import Component_Organisation_Customisation from "../../account/organisation/component_organisation_customisation";

let loading = false;
let tab;
let currentPage;

const Page_AdminOrganisation = {
    oninit: function () {
        tab = Auth.validateRights(["org_view"]) ? "details" : "customisation";
        currentPage = "settings";
    },
    view: function () {
        return [
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section with-menu", [
                        m("h1", i18n.t("organisation")),
                        m(".toolbar-menu", [
                            Auth.validateRights(["org_view"], m("div", {
                                class: tab === "details" ? "active" : "",
                                onclick: function () { tab = "details"; }
                            }, i18n.t("details"))),
                            Auth.validateRights(["courses_manage_categories"], m("div", {
                                class: tab === "customisation" ? "active" : "",
                                onclick: function () { tab = "customisation"; }
                            }, i18n.t("customisation")))
                        ])
                    ])
                ])
            ]),
            !loading ? [
                tab === "details" ? m(Component_Organisation_Details)
                    : tab === "customisation" ? m(Component_Organisation_Customisation)
                        : null
            ] : m(".text-gray content-box", [i18n.t("loading"), m(".loading-dots")])
        ];
    }
};

export default Page_AdminOrganisation;
